import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PatientIntroduction = ({ onNext, onBack, onSkip }) => {
  const samplePatients = [
  {
    id: 1,
    name: 'Maria Silva',
    avatar: `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/public-images/paciente1.png`,
    avatarAlt: 'Mulher brasileira de cabelos castanhos longos com sorriso amigável em fundo neutro',
    phone: '(11) 98765-4321',
    lastVisit: '28/11/2025',
    totalSessions: 12,
    status: 'active'
  },
  {
    id: 2,
    name: 'João Santos',
    avatar: `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/public-images/paciente2.png`,
    avatarAlt: 'Homem brasileiro de cabelos pretos curtos com barba em traje casual',
    phone: '(11) 97654-3210',
    lastVisit: '01/12/2025',
    totalSessions: 8,
    status: 'active'
  },
  {
    id: 3,
    name: 'Ana Costa',
    avatar: `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/public-images/paciente3.png`,
    avatarAlt: 'Mulher brasileira de cabelos loiros médios com óculos em ambiente profissional',
    phone: '(11) 96543-2109',
    lastVisit: '15/11/2025',
    totalSessions: 5,
    status: 'pending'
  }];


  const features = [
  {
    icon: 'UserPlus',
    title: 'Cadastro Rápido',
    description: 'Adicione pacientes com informações essenciais em segundos'
  },
  {
    icon: 'Phone',
    title: 'Contato Direto',
    description: 'Telefone e WhatsApp integrados para comunicação fácil'
  },
  {
    icon: 'Calendar',
    title: 'Histórico Completo',
    description: 'Acompanhe todas as sessões e evolução do paciente'
  },
  {
    icon: 'FileText',
    title: 'Notas e Observações',
    description: 'Registre informações importantes de cada consulta'
  }];


  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-xl p-6 border border-primary/20">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
            <Icon name="Users" size={24} color="#FFFFFF" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-foreground mb-2">
              Gerencie Seus Pacientes com Facilidade
            </h3>
            <p className="text-muted-foreground">
              O sistema de gestão de pacientes permite organizar informações, acompanhar histórico de sessões e manter contato direto via WhatsApp. Tudo em um só lugar.
            </p>
          </div>
        </div>
      </div>

        <div className="mt-4 p-4 bg-accent/10 rounded-lg border border-accent/20">
          <p className="text-sm text-foreground flex items-start gap-2">
            <Icon name="Info" size={16} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
            <span>
              Você poderá adicionar seus pacientes reais após concluir o onboarding. Os dados abaixo são apenas exemplos ilustrativos.
            </span>
          </p>
        </div>

      { /*
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {features?.map((feature) =>
        <div
          key={feature?.title}
          className="bg-card rounded-lg p-4 border border-border hover:border-primary/50 transition-all duration-200">

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div>
                <h4 className="font-medium text-foreground mb-1">
                  {feature?.title}
                </h4>
                <p className="text-sm text-muted-foreground">
                  {feature?.description}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
      */}

      <div className="bg-card rounded-xl p-6 border border-border">
        {/*
        <h4 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Eye" size={20} color="var(--color-primary)" />
          Exemplo de Lista de Pacientes
        </h4>
        */}
        
        <div className="space-y-3">
          {samplePatients?.map((patient) =>
          <div
            key={patient?.id}
            className="flex items-center justify-between p-4 bg-muted/50 rounded-lg hover:bg-muted transition-all duration-200">

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-border">
                  <Image
                  src={patient?.avatar}
                  alt={patient?.avatarAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div>
                  <p className="font-medium text-foreground">{patient?.name}</p>
                  <div className="flex items-center gap-3 mt-1">
                    <span className="text-xs text-muted-foreground flex items-center gap-1">
                      <Icon name="Phone" size={12} />
                      {patient?.phone}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      {patient?.totalSessions} sessões
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-right">
                <span
                className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                patient?.status === 'active' ? 'bg-success/10 text-success' : 'bg-warning/10 text-warning'}`
                }>

                  <Icon
                  name={patient?.status === 'active' ? 'CheckCircle' : 'Clock'}
                  size={12} />

                  {patient?.status === 'active' ? 'Ativo' : 'Pendente'}
                </span>
                <p className="text-xs text-muted-foreground mt-1">
                  Última visita: {patient?.lastVisit}
                </p>
              </div>
            </div>
          )}
        </div>

      </div>
      <div className="flex items-center justify-between pt-4">
        <Button
          type="button"
          variant="outline"
          onClick={onBack}
          iconName="ChevronLeft"
          iconPosition="left">

          Voltar
        </Button>
        <div className="flex items-center gap-2">
          <Button type="button" variant="ghost" onClick={onSkip}>
            Pular
          </Button>
          <Button
            type="button"
            variant="default"
            onClick={onNext}
            iconName="ChevronRight"
            iconPosition="right">

            Continuar
          </Button>
        </div>
      </div>
    </div>);

};

export default PatientIntroduction;